import React from 'react';
// import yearInPixels from "./images/appIcons/yip.png";
import nightlight from "./images/appIcons/nightlight.png";
import randomizer from "./images/appIcons/randomizer.png";
import tracker from "./images/appIcons/tracker.png";
import countdown from "./images/appIcons/countdown.png";
import brighten from "./images/appIcons/brighten.png";
import happiness from "./images/appIcons/happiness.png";
// import PageContactDetail from "./pages/Pages/Contact/PageContactDetail";

// const PageAboutUs = React.lazy(() => import('./pages/Pages/PageAboutUs'));
const Apps = React.lazy(() => import('./pages/Apps/index'));
const PageContactDetail = React.lazy(() => import('./pages/Pages/Contact/PageContactDetail'));
const AboutUs = React.lazy(() => import('./pages/Pages/PageAboutUs'));
// const yip = React.lazy(() => import('./pages/Apps/yip'));
const NigthLight = React.lazy(() => import('./pages/Apps/NightLight'));
const Randomizer = React.lazy(() => import('./pages/Apps/Randomizer'));
const CalendarProgressTracker = React.lazy(() => import('./pages/Apps/CalendarProgressTracker'));
const Countdown = React.lazy(() => import('./pages/Apps/Countdown'));
const Scanner = React.lazy(() => import('./pages/Apps/Scanner'));
const BrightenMyDay = React.lazy(() => import('./pages/Apps/BrightenMyDay'));
const Happiness = React.lazy(() => import('./pages/Apps/Happiness'));

const routes = [
    // { path: '/om-oss', component: PageAboutUs },
    { path: '/contact-us', component: PageContactDetail },
    { path: '/about', component: AboutUs },
    { path: '/', component: Apps },
    // { path : "/apps/year-in-pixels-mood-analyser", component: yip },
    { path : "/apps/night-light-reading-lamp", component: NigthLight },
    { path : "/apps/randomizer-random-generator", component: Randomizer },
    { path : "/apps/calendar-progress-tracker", component: CalendarProgressTracker },
    { path : "/apps/countdown-calendar-tracker", component: Countdown },
    { path : "/apps/brighten-my-day-daily-quotes", component: BrightenMyDay },
    { path : "/apps/happiness-detector-mood-analyser", component: Happiness },
    { path : "/apps/qr-code-barcode-scanner", component: Scanner },
];

export default routes;
